module.exports = __webpack_public_path__ + "img/nol-back.1a438fd0.png";